// extracted by mini-css-extract-plugin
export default {"root":"TaskManagement_root__xUe5H","header":"TaskManagement_header__uwpXu","panel":"TaskManagement_panel__KER+1"};